import axios from 'axios'

export const locationStoreModule = {
	namespaced: true,
	state: {
		location: null
	},
	mutations: {
		SET_LOCATION(state, payload) {
			state.location = payload.location 
		},
		RESTORE_LOCATION_FROM_STORAGE(state) {
			const storedIp = localStorage.getItem('ip')
			const storedLocation = localStorage.getItem('locationData')
			
			if (storedLocation) {
				try {
					state.location = JSON.parse(storedLocation)
				} catch (e) {
					console.error('Failed to parse stored location', e)
					if (storedIp) {
						state.location = { ip: storedIp }
					}
				}
			} else if (storedIp) {
				state.location = { ip: storedIp }
			}
		}
	},
	actions: {
		RESTORE_FROM_STORAGE: (context) => {
			context.commit('RESTORE_LOCATION_FROM_STORAGE')
		},
		GET_USER_LOCATION_DATA: async (context) => {
			if (context.state.location !== null && context.state.location.city) {
				return { data: context.state.location, error: undefined }
			}

			try {
				const ipResponse = await axios.get('https://api.ipify.org?format=json')
				localStorage.setItem('ip', ipResponse.data.ip)

				if (ipResponse.status !== 200 || !ipResponse.data.ip)
					throw new Error('cant retrive ip from api')

				const res = await axios.get(`https://ipapi.co/${ipResponse.data.ip}/json/`)

				if (res.status !== 200 || !res.data) throw new Error('cant retrive location from api')

				context.commit('SET_LOCATION', { location: res.data })
				
				// Store full location data
				localStorage.setItem('locationData', JSON.stringify(res.data))

				console.log('Location data fetched:', res.data)

				return { data: res.data, error: undefined }
			} catch (e) {
				console.error('Location fetch error:', e)
				
				// Try to use stored IP as fallback
				const storedIp = localStorage.getItem('ip')
				if (storedIp) {
					const fallbackData = { ip: storedIp }
					context.commit('SET_LOCATION', { location: fallbackData })
					return { data: fallbackData, error: undefined }
				}
				
				return { data: undefined, error: 'cant retrive location data from api' }
			}
		}
	},
	getters: {
		getLocationIpAddress(state) {
			return state.location ? state.location.ip : null
		},
		getLocationCity(state){
			return state.location ? state.location.city : null
		},
		getLocationState(state){
			return state.location ? state.location.region : null
		},
		getLocationCountry(state){
			return state.location ? state.location.country_name : null
		}
	}
}
